import React from "react";
import {Link} from "react-router-dom";

// NTS 1:50k sheet references as trail write-ups spell them: "92G14", "092 J/10",
// "82K/2", "92 G / 07". Series run 001-560, areas A-P, sheets 1-16.
const NTS_SHEET = /\b(\d{2,3}) ?([A-P]) ?(?:\/ ?)?(1[0-6]|0?[1-9])(?!\d)/g;

// Our NTS page for the sheet, e.g. "/nts/092g14", or null if it isn't a real sheet number.
export function ntsSheetPath(series, area, sheet) {
    const n = parseInt(series, 10);
    if (n < 1 || n > 560) return null;
    const s = String(n).padStart(3, "0");
    const p = String(parseInt(sheet, 10)).padStart(2, "0");
    return `/nts/${s}${area.toLowerCase()}${p}`;
}

// Text with each NTS sheet reference turned into a link to its map download page.
export function linkNtsMaps(text) {
    const parts = [];
    let last = 0;
    for (const match of text.matchAll(NTS_SHEET)) {
        const path = ntsSheetPath(match[1], match[2], match[3]);
        if (!path) continue;
        parts.push(text.slice(last, match.index));
        parts.push(<Link key={match.index} to={path} title="Download this NTS map">{match[0]}</Link>);
        last = match.index + match[0].length;
    }
    if (parts.length === 0) return text;
    parts.push(text.slice(last));
    return parts;
}
